"use client"

import { Cross } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CrossIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CrossIcon = component(Icon)({ as: Cross })
